import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function OverlayCloseButton ({
	hideOverlay,
	children = undefined,
	variant = 'x',
	className
}) {

	const buttonBaseClassName = 'Overlay__contentWrapper__closeButton';
	const buttonClassName = classNames(buttonBaseClassName, {
		[`${buttonBaseClassName}--text`]: variant === 'text'
	});
	const classNameSpan = classNames(className, {
		'lpIcon-close02': variant === 'x' && !className
	});

	return (
		<button
			onClick={() => hideOverlay()}
			className={buttonClassName}
			aria-label="Close"
			type="button"
		>
			<span className={classNameSpan}>
				{variant === 'text' ? 'Close' : null}
			</span>
			{children}
		</button>
	);

}

OverlayCloseButton.propTypes = {
	children: PropTypes.oneOfType([ PropTypes.node, PropTypes.arrayOf(PropTypes.node) ]),
	hideOverlay: PropTypes.func.isRequired,
	className: PropTypes.string,
	variant: PropTypes.string
};

export default OverlayCloseButton;
